import React, { useCallback, useMemo } from 'react';

import styled from 'styled-components';

import { DocumentsSections } from '@cd3p/core/modules/documents';
import { APIDocumentSearchResult, APIUserType } from '@cd3p/core/types/api';
import { Stack, Typography } from 'components';

import { dayjs, useSelector, useTranslation } from 'third-party';

import { appSelectors } from 'selectors';

import { Docs } from 'features/Docs/Docs';

const DateInfo = styled(Typography)`
  font-size: 1.2rem;
  font-weight: 900;
  line-height: 125%;
  text-transform: uppercase;
  color: ${props => props.theme.custom.palette.secondary700};
`;

const Title = styled(Typography)`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 150%;
  color: ${props => props.theme.custom.palette.darkText};
`;

export const ReleaseNotes = () => {
  const { t } = useTranslation();

  const userType = useSelector(appSelectors.userType);

  const menuItemRenderer = useCallback((it: APIDocumentSearchResult) => {
    return (
      <Stack>
        <DateInfo>
          {dayjs(it.document?.publishedDate).format('MMMM D, YYYY')}
        </DateInfo>
        <Title>{it.document?.title}</Title>
      </Stack>
    );
  }, []);

  const documentsSection = useMemo(() => {
    return userType === APIUserType.Contractor
      ? DocumentsSections.WhatIsNewWebContractor
      : DocumentsSections.WhatIsNewWebDispatcher;
  }, [userType]);

  return (
    <Docs
      pageName={t('docs.whatsNew')}
      menuItemRenderer={menuItemRenderer}
      documentsSection={documentsSection}
    />
  );
};
